import Siema from 'siema';
import { Component } from 'js-component-framework';

/**
 * Component for instantiating Carousel w/ Thumbs.
 */
export default class Carousel extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Initalizations
    this.setCarousel();
    this.setPrevNextTriggers();
    this.setCurrentSlide();
  }

  /**
   * Set Main and Navigation Carousels
   * @see https://pawelgrzybek.com/siema/
   */
  setCarousel() {
    // Main Carousel
    this.carousel = new Siema({
      selector: this.children.viewport,
      draggable: false,
      multipleDrag: false,
    });

    // Navigation Carousel
    this.carouselNav = new Siema({
      selector: this.children.navigationThumbWrapper,
      perPage: {
        0: 2,
        520: 3,
        620: 4,
      },
      draggable: false,
      multipleDrag: false,
      loop: true,
    });
  }

  /**
   * Set Prev/Next Buttons for Carousel Nav
   */
  setPrevNextTriggers() {
    this.children.navigationPrev.addEventListener('click', () => {
      this.carouselNav.prev();
    });

    this.children.navigationNext.addEventListener('click', () => {
      this.carouselNav.next();
    });
  }

  /**
   * Set main carousel to the selected slide in navigation
   */
  setCurrentSlide() {
    Array.prototype.forEach.call(this.children.navigationThumbs, (thumb) => {
      const thumbLink = thumb.querySelector('a');
      thumbLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.carousel.goTo(
          parseInt(event.currentTarget.dataset.slideIndex, 10)
        );
        this.setNavActiveClass(thumbLink.parentElement);
      });
    });
  }

  /**
   * Set a navigation slide to active
   * @param {HTML Element} activateElement the slide to become active
   */
  setNavActiveClass(activateElement) {
    // Reset - Remove class from all existing active class
    Array.prototype.forEach.call(this.children.navigationThumbs, (thumb) => {
      thumb.classList.remove(this.options.navSlideActiveClass);
    });
    // Set active class to selected slide
    activateElement.classList.add(this.options.navSlideActiveClass);
  }
}



// WEBPACK FOOTER //
// ./client/js/components/Carousel/Carousel.js